module.exports = __webpack_public_path__ + "1791188489487/images/socicon.a35b657.svg";